import {
  EVENTS_BY_DISCIPLINE,
  DISCIPLINE_NAMES,
  CATEGORIES_BY_DISCIPLINE
} from './constants';

/**
 * Obtiene los aparatos disponibles para un evento
 */
export const getApparatusForEvent = (event) => {
  if (!event.discipline || !event.category) {
    return [];
  }

  const disciplineEvents = EVENTS_BY_DISCIPLINE[event.discipline];
  if (!disciplineEvents) return [];

  const categoryEvents = disciplineEvents[event.category];
  if (!categoryEvents) return [];

  // Si el evento especifica aparatos, usar esos, sino usar todos disponibles
  if (event.apparatus && event.apparatus.length > 0) {
    return categoryEvents.filter(e => event.apparatus.includes(e.code));
  }

  return categoryEvents;
};

/**
 * Obtiene el nombre de la disciplina
 */
export const getDisciplineName = (discipline) => {
  return DISCIPLINE_NAMES[discipline] || discipline;
};

/**
 * Obtiene el nombre de la categoría
 */
export const getCategoryName = (discipline, category) => {
  const categories = CATEGORIES_BY_DISCIPLINE[discipline];
  if (!categories) return category;
  return categories[category] || category;
};

/**
 * Obtiene todos los aparatos para un evento formateados para mostrar
 */
export const getApparatusDisplayList = (event) => {
  const apparatus = getApparatusForEvent(event);
  return apparatus.map(a => ({
    code: a.code,
    name: a.name,
    apparatus: a.apparatus
  }));
};

/**
 * Calcula el all-around basado en los scores de los aparatos
 */
export const calculateAllAround = (scores, apparatus) => {
  if (!scores || !apparatus || apparatus.length === 0) {
    return 0;
  }

  let total = 0;
  let count = 0;

  apparatus.forEach(app => {
    if (scores[app.apparatus] !== undefined) {
      total += scores[app.apparatus];
      count++;
    }
  });

  return count > 0 ? (total / count).toFixed(2) : 0;
};

/**
 * Calcula el total de puntos basado en los scores
 */
export const calculateTotal = (scores, apparatus) => {
  if (!scores || !apparatus || apparatus.length === 0) {
    return 0;
  }

  let total = 0;

  apparatus.forEach(app => {
    if (scores[app.apparatus] !== undefined) {
      total += scores[app.apparatus];
    }
  });

  return total.toFixed(2);
};
